import React, { useState } from 'react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Play, Mail, Sparkles, Clock } from 'lucide-react';
import { APP_DASHBOARD_URL } from '../lib/appUrl';

// Toggle to embed an actual video once recorded.
// Set DEMO_VIDEO_URL to a Loom/YouTube embed URL (e.g. 'https://www.loom.com/embed/abc123').
const DEMO_VIDEO_URL = null;

const DemoVideoModal = ({ trigger }) => {
  const [open, setOpen] = useState(false);
  const [notified, setNotified] = useState(false);

  const handleNotify = () => {
    window.location.href =
      'mailto:support@vibesprint.ai?subject=Notify%20me%20when%20the%20demo%20video%20launches';
    setNotified(true);
  };

  return (
    <>
      <span onClick={() => setOpen(true)}>{trigger}</span>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          className="sm:max-w-[860px] p-0 overflow-hidden"
          data-testid="demo-video-modal"
        >
          <DialogHeader className="px-6 pt-6">
            <DialogTitle className="flex items-center gap-2 text-2xl">
              <Sparkles className="h-5 w-5 text-primary" />
              See VibeSprint in 60 seconds
            </DialogTitle>
            <DialogDescription>
              Watch how AI categorizes feedback into Build / Fix / Ignore lanes — no signup required.
            </DialogDescription>
          </DialogHeader>

          <div className="px-6 pb-6">
            {DEMO_VIDEO_URL ? (
              <div
                className="aspect-video w-full rounded-lg overflow-hidden bg-muted border"
                data-testid="demo-video-iframe-wrapper"
              >
                <iframe
                  src={DEMO_VIDEO_URL}
                  title="VibeSprint 60-second demo"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            ) : (
              // Placeholder when no recording is ready yet
              <div
                className="aspect-video w-full rounded-lg border-2 border-dashed bg-gradient-to-br from-primary/5 via-card to-primary/10 flex flex-col items-center justify-center p-8 text-center"
                data-testid="demo-video-placeholder"
              >
                <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                  <Play className="h-7 w-7 text-primary ml-1" />
                </div>
                <h3 className="text-xl font-bold mb-2">Demo video coming soon</h3>
                <p className="text-sm text-muted-foreground max-w-md mb-6">
                  We're recording a polished 60-second walkthrough. In the meantime, the live dashboard is the fastest way to see it work.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto justify-center">
                  <Button
                    asChild
                    className="btn-cta"
                    data-testid="demo-video-try-live"
                  >
                    <a href={APP_DASHBOARD_URL} onClick={() => setOpen(false)}>
                      <Sparkles className="h-4 w-4 mr-2" />
                      Open dashboard
                    </a>
                  </Button>
                  <Button
                    variant="outline"
                    onClick={handleNotify}
                    disabled={notified}
                    data-testid="demo-video-notify-button"
                  >
                    {notified ? (
                      <>
                        <Mail className="h-4 w-4 mr-2" />
                        We'll be in touch
                      </>
                    ) : (
                      <>
                        <Mail className="h-4 w-4 mr-2" />
                        Notify me when it launches
                      </>
                    )}
                  </Button>
                </div>
                <div className="mt-6 flex items-center gap-2 text-xs text-muted-foreground">
                  <Clock className="h-3 w-3" />
                  <span>Estimated launch: this month</span>
                </div>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DemoVideoModal;
